import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { Notification, NotificationCategories } from '@core/domain/model/notifications/notification.model';
import { NgClass } from '@angular/common';
import { NoDataFoundComponent } from '@shared/ui-components/info-box/no-data-found/no-data-found.component';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { notificationsSelectors } from '@store/selectors/notifications.selectors';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationComponent } from '@shared/components/notifications-list/notification/notification.component';
import { InfoBoxComponent } from '@shared/ui-components/info-box/info-box.component';
import { appSelectors } from '@store/selectors/app.selectors';
import { LoadingIds } from '@shared/constants/loading';

@Component({
  selector: 'ac-notifications-list',
  standalone: true,
  imports: [NotificationComponent, NgClass, NoDataFoundComponent, TranslateModule, InfoBoxComponent],
  templateUrl: './notifications-list.component.html',
  styleUrl: './notifications-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsListComponent {
  @Input() notifications: Notification[] = [];
  @Input() fullWidth: boolean = false;
  @Input({ required: true }) currentCategory!: NotificationCategories;
  @Output() clickedNotification = new EventEmitter();

  protected readonly _loadingSig = computed(() =>
    this._store.selectSignal(appSelectors.specificLoading)().includes(LoadingIds.NOTIFICATIONS_PANEL)
  );
  protected readonly _errorSig = this._store.selectSignal(notificationsSelectors.notificationsError);

  constructor(private readonly _store: Store<StoreState>) {}

  protected _onClickNotification() {
    this.clickedNotification.emit();
  }
}
